import { twMerge } from "tailwind-merge";

export const PrinterIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={twMerge("hover:text-darkblue text-[#9CA3AF]", className)}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="currentColor"
    >
      <path
        d="M19.0667 5.3V5.62164L19.3881 5.63312C20.2614 5.66431 20.9825 6.38352 21.0167 7.25619V12.65C21.0167 13.5137 20.3032 14.2355 19.4256 14.2669L19.1042 14.2784V14.6V21.2375C19.1042 22.1409 18.3534 22.8917 17.45 22.8917H4.4C3.4966 22.8917 2.74583 22.1409 2.74583 21.2375V14.6V14.2784L2.4244 14.2669C1.54683 14.2355 0.833333 13.5137 0.833333 12.65V7.25C0.833333 6.3863 1.54683 5.66446 2.4244 5.63312L2.74583 5.62164V5.3V2.4875C2.74583 1.5841 3.4966 0.833333 4.4 0.833333H17.4125C18.3159 0.833333 19.0667 1.5841 19.0667 2.4875V5.3ZM17.7875 5.63333H18.1208V5.3V2.4875C18.1208 2.0892 17.7937 1.85417 17.4875 1.85417H4.4375C4.0392 1.85417 3.80417 2.1813 3.80417 2.4875V5.3V5.63333H4.1375H17.7875ZM4.1 14.2667H3.76667V14.6V21.2375C3.76667 21.6358 4.0938 21.8708 4.4 21.8708H17.4125C17.8108 21.8708 18.0458 21.5437 18.0458 21.2375V14.6V14.2667H17.7125H4.1ZM19.325 13.2833C19.7233 13.2833 19.9583 12.9562 19.9583 12.65V7.25C19.9583 6.8517 19.6312 6.61667 19.325 6.61667H2.4875C2.0892 6.61667 1.85417 6.9438 1.85417 7.25V12.65C1.85417 13.0483 2.1813 13.2833 2.4875 13.2833H19.325Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.666667"
      />
      <path
        d="M8.1125 17.4877H13.7375C14.1875 17.4877 14.6 17.1127 14.6 16.6252C14.6 16.1377 14.225 15.7627 13.7375 15.7627H8.1125C7.6625 15.7627 7.25 16.1377 7.25 16.6252C7.25 17.1127 7.6625 17.4877 8.1125 17.4877Z"
        fill="currentColor"
      />
      <path
        d="M17.675 8.5625H14.8625C14.4125 8.5625 14 8.9375 14 9.425C14 9.9125 14.375 10.2875 14.8625 10.2875H17.675C18.125 10.2875 18.5375 9.9125 18.5375 9.425C18.5375 8.9375 18.1625 8.5625 17.675 8.5625Z"
        fill="currentColor"
      />
      <path
        d="M8.1125 20.3373H13.7375C14.1875 20.3373 14.6 19.9623 14.6 19.4748C14.6 18.9873 14.225 18.6123 13.7375 18.6123H8.1125C7.6625 18.6123 7.25 18.9873 7.25 19.4748C7.25 19.9623 7.6625 20.3373 8.1125 20.3373Z"
        fill="currentColor"
      />
    </svg>
  );
};
